import { computed } from 'vue';

export function useTripTitles(activeRedemption) {
    const flightTitle = computed(() => {
        if (activeRedemption.value.travel_segments.length === 1) {
            if (activeRedemption.value.date_type === 'start') {
                if (activeRedemption.value.travel_segments[0].origin_airport) {
                    return (
                        '(' +
                        activeRedemption.value.travel_segments[0].origin +
                        ') ' +
                        activeRedemption.value.travel_segments[0].origin_airport
                            .city +
                        ' - ' +
                        (activeRedemption.value.travel_segments[0]
                            .destination_airport
                            ? '(' +
                              activeRedemption.value.travel_segments[0]
                                  .destination +
                              ') ' +
                              activeRedemption.value.travel_segments[0]
                                  .destination_airport.city +
                              ', ' +
                              activeRedemption.value.travel_segments[0]
                                  .destination_airport.country
                            : activeRedemption.value.travel_segments[0]
                                  .destination)
                    );
                } else {
                    return activeRedemption.value.travel_segments[0].origin?.toUpperCase() || '';
                }
            } else {
                return activeRedemption.value.travel_segments[0]
                    .destination_airport
                    ? '(' +
                          activeRedemption.value.travel_segments[0]
                              .destination +
                          ') ' +
                          activeRedemption.value.travel_segments[0]
                              .destination_airport.city +
                          ', ' +
                          activeRedemption.value.travel_segments[0]
                              .destination_airport.country
                    : activeRedemption.value.travel_segments[0].destination;
            }
        } else if (activeRedemption.value.travel_segments.length > 1) {
            if (activeRedemption.value.date_type === 'start') {
                return activeRedemption.value.travel_segments[0].origin_airport
                    ? activeRedemption.value.travel_segments[0].origin_airport
                          ?.city +
                          ', ' +
                          activeRedemption.value.travel_segments[0]
                              .origin_airport?.country
                    : (activeRedemption.value.travel_segments[0].origin || '') +
                        ' - ' +
                        activeRedemption.value.travel_segments[
                            activeRedemption.value.travel_segments.length - 1
                        ].destination_airport
                      ? activeRedemption.value.travel_segments[
                            activeRedemption.value.travel_segments.length - 1
                        ].destination_airport?.city +
                        ', ' +
                        activeRedemption.value.travel_segments[
                            activeRedemption.value.travel_segments.length - 1
                        ].destination_airport?.country
                      : (activeRedemption.value.travel_segments[
                            activeRedemption.value.travel_segments.length - 1
                        ].destination || '');
            } else {
                return activeRedemption.value.travel_segments[
                    activeRedemption.value.travel_segments.length - 1
                ].destination_airport
                    ? activeRedemption.value.travel_segments[
                          activeRedemption.value.travel_segments.length - 1
                      ].destination_airport.city +
                          ', ' +
                          activeRedemption.value.travel_segments[
                              activeRedemption.value.travel_segments.length - 1
                          ].destination_airport.country
                    : (activeRedemption.value.travel_segments[
                          activeRedemption.value.travel_segments.length - 1
                      ].destination || '');
            }
        }
        return '';
    });

    const trainTitle = computed(() => {
        if (activeRedemption.value.travel_segments.length === 1) {
            return (
                (activeRedemption.value.travel_segments[0].origin || '') +
                ' - ' +
                (activeRedemption.value.travel_segments[0].destination || '')
            );
        } else if (activeRedemption.value.travel_segments.length > 1) {
            return (
                (activeRedemption.value.travel_segments[0].origin || '') +
                ' - ' +
                (activeRedemption.value.travel_segments[
                    activeRedemption.value.travel_segments.length - 1
                ].destination || '')
            );
        }
        return 'Train';
    });

    const rentalTitle = computed(() => {
        const pickup = activeRedemption.value.pickup_location || '';
        const dropoff = activeRedemption.value.dropoff_location || '';

        if (!pickup && !dropoff) {
            return '';
        }
        if (pickup === dropoff) {
            return pickup;
        }
        if (pickup && dropoff) {
            return `${pickup} - ${dropoff}`;
        }
        return pickup || dropoff;
    });

    return {
        flightTitle,
        trainTitle,
        rentalTitle,
    };
}
